import { useCallback, useEffect, useState } from 'react';

const isOptanonAlertBoxClosed = () => {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.cookie.includes('OptanonAlertBoxClosed');
};

export const useCookieConsentClosed = () => {
  const [isCookieConsentClosed, setHasCookieConsentClosed] = useState(
    isOptanonAlertBoxClosed(),
  );

  const handleOneTrustConsent = useCallback(() => {
    setHasCookieConsentClosed(false);
  }, []);

  useEffect(() => {
    window.addEventListener('consent.onetrust', handleOneTrustConsent);

    return () => {
      window.removeEventListener('consent.onetrust', handleOneTrustConsent);
    };
  }, [handleOneTrustConsent]);

  return isCookieConsentClosed;
};
